import { render, staticRenderFns } from "./sliderView.vue?vue&type=template&id=afbd7b80&"
import script from "./sliderView.vue?vue&type=script&lang=js&"
export * from "./sliderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports